var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBtnMultipleGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0625 11C2.0625 6.06562 6.06562 2.0625 11 2.0625C15.9344 2.0625 19.9375 6.06562 19.9375 11C19.9375 15.9344 15.9344 19.9375 11 19.9375C6.06562 19.9375 2.0625 15.9344 2.0625 11ZM11 3.4375C6.82501 3.4375 3.4375 6.82501 3.4375 11C3.4375 15.175 6.82501 18.5625 11 18.5625C15.175 18.5625 18.5625 15.175 18.5625 11C18.5625 6.82501 15.175 3.4375 11 3.4375ZM11 6.875C11.3797 6.875 11.6875 7.1828 11.6875 7.5625V10.3125H14.4375C14.8172 10.3125 15.125 10.6203 15.125 11C15.125 11.3797 14.8172 11.6875 14.4375 11.6875H11.6875V14.4375C11.6875 14.8172 11.3797 15.125 11 15.125C10.6203 15.125 10.3125 14.8172 10.3125 14.4375V11.6875H7.5625C7.1828 11.6875 6.875 11.3797 6.875 11C6.875 10.6203 7.1828 10.3125 7.5625 10.3125H10.3125V7.5625C10.3125 7.1828 10.6203 6.875 11 6.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBtnMultipleGrid);
export default __webpack_public_path__ + "static/media/add-btn-multiple-grid.4c7134eff0602079bf5913a4061fdce7.svg";
export { ForwardRef as ReactComponent };